// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LKgi","left":"styles_left__2AvX_","right":"styles_right__2Z0wB","alert":"styles_alert__1jaPD"};